import { configs } from '@constants/configs/configs';
import { launchActionTypes } from '@constants/actionTypes/ssapActionTypes';
import { localStorageHyperDashboardTools } from '@utils/tools/localStorageHyperDashboardTools';
import { mockState } from '@mocks/stabs/mockState';

const getSsapApplicationId = () => {
    return configs.ENV.EXPLICIT_PRODUCTION
        ? (window.ssapApplicationObj?.ssapId ?? null)
        : localStorageHyperDashboardTools.getValueByPropName('mockJson', 'threeHhms');
};

export const INITIAL_STATE = {
    backLinkText: null,
    backUrl: null,
    caseNumber: null,
    consumer: 'SSAP',
    flowCreated: false,
    isInReviewMode: false,
    loadBy: 'ssapId',
    ssapApplicationId: getSsapApplicationId(),
    watchForDuplications: true
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case launchActionTypes.SET_SSAP_LAUNCH:
            return {
                ...state,
                ...action.launchConfig
            };
        case launchActionTypes.SET_SSAP_IN_REVIEW_MODE:
            return {
                ...state,
                isInReviewMode: true // So far we believe that once in review mode, we don't need to switch back
            };
        case launchActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        case launchActionTypes.CUSTOM_MIDDLEWARE_FLOW_ADJUSTMENT_COMPLETED:
            return {
                ...state,
                flowCreated: true // This indicates that the flow has been finally adjusted and is ready for use
            };
        default:
            return state;
    }
};

export const selectIfSsapInReviewMode = state => state.isInReviewMode;